import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PieChart, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { fmt } from "@/components/shared";

export function SharesSummaryCard() {
  const [d, setD] = useState(null);
  const nav = useNavigate();
  useEffect(() => { api.get("/shares/me").then((r) => setD(r.data)).catch(() => setD(false)); }, []);
  if (!d) return null;
  const h = d.holding, pendingDeps = d.deposits.filter((x) => x.status === "pending").length;
  return (
    <div className="glass rounded-2xl p-5 lg:p-6 flex flex-col md:flex-row md:items-center gap-5" data-testid="dashboard-shares-card">
      <div className="w-11 h-11 rounded-xl bg-cyan-500/15 flex items-center justify-center shrink-0 share-icon-glow"><PieChart className="w-5 h-5 text-cyan-300" /></div>
      <div className="flex-1 grid grid-cols-2 sm:grid-cols-4 gap-4">
        <div><p className="text-xs text-slate-500 uppercase tracking-wider">My Shares</p><p className="font-mono text-xl text-white" data-testid="dash-shares-count">{h.shares}</p></div>
        <div><p className="text-xs text-slate-500 uppercase tracking-wider">Share Price</p><p className="font-mono text-xl text-white">{fmt(d.info.share_price)} <span className="text-xs text-slate-500 font-sans">USDT</span></p></div>
        <div><p className="text-xs text-slate-500 uppercase tracking-wider">Holding Value</p><p className="font-mono text-xl text-emerald-300" data-testid="dash-shares-value">{fmt(h.current_value)} <span className="text-xs text-slate-500 font-sans">USDT</span></p></div>
        <div><p className="text-xs text-slate-500 uppercase tracking-wider">Pending</p><p className="font-mono text-sm text-slate-200 mt-1.5">{h.pending_shares} shares · {pendingDeps} deposit{pendingDeps === 1 ? "" : "s"}</p></div>
      </div>
      <button onClick={() => nav("/shares-portal")} data-testid="dash-shares-btn" className="glass glass-hover px-5 py-2.5 rounded-full text-sm text-cyan-300 inline-flex items-center gap-2 shrink-0">
        Company Shares <ArrowRight className="w-4 h-4" />
      </button>
    </div>
  );
}
